// extracted by mini-css-extract-plugin
export default {"dark":"constructor-item_dark__wBY5t","item":"constructor-item_item__2MUsg","dragging":"constructor-item_dragging__M7vjS"};